module.exports = __webpack_public_path__ + "media/entities/2317-10c8a4cb.png";